import { render } from "./NewChatGroup.vue?vue&type=template&id=98ec4f36"
import script from "./NewChatGroup.vue?vue&type=script&lang=js"
export * from "./NewChatGroup.vue?vue&type=script&lang=js"

import "./NewChatGroup.vue?vue&type=style&index=0&id=98ec4f36&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__